import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { region } from "../../store/region/actions";
export var useRegionGetAll = function (trigger, name, zipcode, code, type, parentRegionId, clientId, page, limit) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return ({
        responseRegion: state.Region.responseRegion,
        errorRegion: state.Region.errorRegion,
        loadingRegion: state.Region.loadingRegion,
    }); }), responseRegion = _b.responseRegion, errorRegion = _b.errorRegion, loadingRegion = _b.loadingRegion;
    useEffect(function () {
        if (trigger === true) {
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                name: name,
                zipcode: zipcode,
                code: code,
                level: type,
                parentRegionId: parentRegionId,
                clientId: clientId,
            }));
        }
    }, [name, zipcode, code, type, parentRegionId, clientId, trigger]);
    return {
        responseRegion: responseRegion,
        errorRegion: errorRegion,
        loadingRegion: loadingRegion,
    };
};
